import { doc, getDoc, updateDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../../firebase/firebase';

/**
 * Upload organisation logo
 */
export async function uploadOrganisationLogo(
  orgId: string,
  logoDataUrl: string
): Promise<void> {
  try {
    // For now, store the data URL directly in Firestore
    // In a production app, you'd upload to Firebase Storage and store the URL
    const orgRef = doc(db, 'Organisations', orgId);
    await updateDoc(orgRef, {
      logoUrl: logoDataUrl,
      updatedAt: serverTimestamp()
    });
  } catch (error) {
    console.error('Error uploading organisation logo:', error);
    throw error;
  }
}

/**
 * Upload partner logos
 */
export async function uploadPartnerLogos(
  orgId: string,
  logoDataUrls: string[]
): Promise<void> {
  try {
    // For now, store the data URLs directly in Firestore
    // In a production app, you'd upload to Firebase Storage and store the URLs
    const orgRef = doc(db, 'Organisations', orgId);
    await updateDoc(orgRef, {
      partnerLogoUrls: logoDataUrls,
      updatedAt: serverTimestamp()
    });
  } catch (error) {
    console.error('Error uploading partner logos:', error);
    throw error;
  }
}

/**
 * Get organisation logos
 */
export async function getOrganisationLogos(
  organisationId: string
): Promise<{ orgLogoUrl?: string, partnerLogoUrls: string[] }> {
  try {
    const orgDoc = await getDoc(doc(db, 'Organisations', organisationId));
    if (!orgDoc.exists()) {
      return { orgLogoUrl: undefined, partnerLogoUrls: [] };
    }
    
    const orgData = orgDoc.data();
    return {
      orgLogoUrl: orgData.logoUrl,
      partnerLogoUrls: orgData.partnerLogoUrls || []
    };
  } catch (error) {
    console.error('Error getting organisation logos:', error);
    // Fallback to mock implementation for now
    if (!organisationId) return { orgLogoUrl: undefined, partnerLogoUrls: [] };
    if (organisationId === 'demo-org') {
      return {
        orgLogoUrl: 'https://upload.wikimedia.org/wikipedia/commons/a/a7/React-icon.svg',
        partnerLogoUrls: [
          'https://upload.wikimedia.org/wikipedia/commons/4/47/React.svg',
          'https://upload.wikimedia.org/wikipedia/commons/6/6a/JavaScript-logo.png'
        ]
      };
    }
    return { orgLogoUrl: undefined, partnerLogoUrls: [] };
  }
}
